import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.FEE.LIST_ALL.REFRESH, () => {
  const requestId = 'listAllFees-' + Date.now();
  bus.emit(constants.EVENTS.FEE.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.FEE.GET_LIST,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.FEE.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.FEE.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.FEE.SUBMIT, saveFee);

async function saveFee(data) {
  const requestId = 'saveFee-' + Date.now();

  bus.emit(constants.EVENTS.LOADING.START);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.FEE.UPDATE,
    method: 'POST',
    data: serializer.serialize(data)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      bus.emit(constants.EVENTS.LOADING.FINISH);
      if (parsed.success) {
        bus.emit(constants.EVENTS.FEE.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.FEE.LIST_ALL.REFRESH);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Frais mis à jour avec succès'
        });
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Echec de sauvegarde',
          body: parsed.message
        });
        bus.emit(constants.EVENTS.FEE.UPDATED, parsed);
      }
    }
  });
}
